export default {
  API_MACHINERY: 'https://access-machinery-service.herokuapp.com',
  API_S3: 'https://d2lkskltni312b.cloudfront.net',
  API_NUCLEUS: 'https://nucleus-service.herokuapp.com',
  // API_NUCLEUS: 'http://localhost:8080',
  API_CACHE: 'https://b8rh6wl2f3.execute-api.us-east-1.amazonaws.com/live'
  // API_CACHE: 'http://localhost:3000',
}
